var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804689 16.5781C0.804689 17.3981 1.07536 18.0955 1.61669 18.6701C2.15802 19.2448 2.81702 19.5318 3.59369 19.5311H18.5397C19.3164 19.5311 19.9754 19.2441 20.5167 18.6701C21.058 18.0961 21.3287 17.3988 21.3287 16.5781V4.68413C21.3287 3.86413 21.0554 3.1588 20.5087 2.56813C19.962 1.97746 19.3057 1.68213 18.5397 1.68213H3.59369C2.82836 1.68213 2.17202 1.97746 1.62469 2.56813C1.07736 3.1588 0.804022 3.86413 0.804689 4.68413V16.5781ZM8.26969 14.4291V6.83313C8.26969 6.75646 8.29169 6.69646 8.33569 6.65313C8.36836 6.64246 8.39569 6.63713 8.41769 6.63713L8.49969 6.65313L15.6527 10.4591C15.6967 10.5031 15.7187 10.5578 15.7187 10.6231C15.7187 10.6671 15.6967 10.7108 15.6527 10.7541L8.49969 14.5601C8.47769 14.5821 8.45569 14.5931 8.43369 14.5931C8.38969 14.5931 8.35702 14.5821 8.33569 14.5601C8.29169 14.5161 8.26969 14.4725 8.26969 14.4291Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ff8b49aca1d89ab61ad5f31762ba2b70.svg";
export { ForwardRef as ReactComponent };